import React from 'react'
import ProductDetailStore from '../store/ProductDetail'

const productDetailStoreContext = React.createContext(ProductDetailStore)

const useProduct = () => React.useContext(productDetailStoreContext)

export default useProduct;
